import { TraceabilityFilter } from 'types/Traceability.types'

export const types = Object.freeze({
  GET_RAW_MATERIAL: '@rawMaterial/getRawMaterial',
  SET_FILTERS_RAW_MATERIAL: '@rawMaterial/setFiltersRawMaterial',
  GET_RAW_MATERIAL_EXPORT: '@rawMaterial/getRawMaterialExported',
  SET_RAW_MATERIAL: '@rawMaterial/setRawMaterial',
  CLEAN_RAW_MATERIAL: '@rawMaterial/cleanRawMaterial'
})

export function getRawMaterial(
  filterRawMaterial?: TraceabilityFilter,
  ordersKeys?: string[]
) {
  return {
    type: types.GET_RAW_MATERIAL,
    payload: { filterRawMaterial, ordersKeys }
  }
}

export function getRawMaterialExported(ordersKeys: string[]) {
  return {
    type: types.GET_RAW_MATERIAL_EXPORT,
    payload: { ordersKeys }
  }
}

export function setFilterRawMaterial(filterRawMaterial: TraceabilityFilter) {
  return { type: types.SET_RAW_MATERIAL, payload: { filterRawMaterial } }
}

export function cleanRawMaterial() {
  return { type: types.CLEAN_RAW_MATERIAL }
}

export function setRawMaterial({ rawMaterial = {} } = {}) {
  return { type: types.SET_RAW_MATERIAL, payload: { rawMaterial } }
}
